import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import GridHeader from './grid-header'
import GridHeaderCorner from '../grid-header-corner'
import GridHeaderTime from '../grid-header-time'
import GridHeaderTimeAdd from '../grid-header-time-add'

import styles from './grid-header.css'

class GridHeaderContainer extends Component {

  constructor(props) {
    super(props)

    this.cornerRenderer = this.cornerRenderer.bind(this)
    this.headerRenderer = this.headerRenderer.bind(this)
  }

  cornerRenderer({ style }) {
    return (
      <GridHeaderCorner key={0} style={style} />
    )
  }

  headerRenderer({ columnIndex, style }) {
    const time = this.props.items.toIndexedSeq().get(columnIndex)
    return time ? <GridHeaderTime key={time.id} style={style} time={time} /> : <GridHeaderTimeAdd style={style} />
  }

  render() {
    return (
      <GridHeader {...this.props} headerRenderer={this.headerRenderer} cornerRenderer={this.cornerRenderer} />
    )
  }
}

GridHeaderContainer.propTypes = {
  items: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  cornerWidth: PropTypes.number.isRequired,
  cellWidth: PropTypes.number.isRequired,
}

export default CSSModules(GridHeaderContainer, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header/grid-header-container.js
 **/